import { createSelector } from '@ngrx/store';

import { onlineMenuState } from '../root';

export const getOnlineMenuData = createSelector(onlineMenuState, (onlineMenu) => onlineMenu.data);
